/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map

// Source - https://stackoverflow.com/a
// Posted by mswyss
// Retrieved 2025-12-18, License - CC BY-SA 3.0

function numbersonly(myfield, e)
{
    var key;
    var keychar;

    if (window.event)
        key = window.event.keyCode;
    else if (e)
        key = e.which;
    else
        return true;

    keychar = String.fromCharCode(key);

    // control keys
    if ((key==null) || (key==0) || (key==8) || (key==9) || (key==13) || (key==27) )
        return true;

    // numbers
    else if ((("0123456789").indexOf(keychar) > -1))
        return true;

    // only one decimal point
    else if ((keychar == "."))
    {
        return false;
    }
    else
        return false;
}

function searchCurrencyFilter() {
  // Declare variables
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById('searchCurrency');
  filter = input.value.toUpperCase();
  ul = document.getElementById('currencyList');
  li = ul.getElementsByTagName('li'); // Get all <li> elements in the list

  // Loop through all list items and hide those that don't match the search query
  for (i = 0; i < li.length; i++) {
    // Get the content to search within (e.g., the <a> tag's text, or the <li>'s textContent)
    a = li[i].querySelector('a') || li[i];
    txtValue = a.textContent || a.innerText;

    // Check if the current list item's text includes the search filter text
    if (txtValue.toUpperCase().includes(filter)) {
      li[i].style.display = ''; // Show the item
    } else {
      li[i].style.display = 'none'; // Hide the item
    }
  }
}


